import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
//Constans
import { defaultMessages } from '../../../constants/Calendar';
import { actionsTable } from '../../../constants/MaterialTable';

//Components
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import FichaRequerimento from '../../Shared/FichaRequerimento';

//Helpers
import { showQuestion, showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../context/auth';

//Api
import agenda_api from '../../../api/agenda_api';
import requerimento_api from '../../../api/requerimento';

//Localizer do calendario
const localizer = momentLocalizer(moment);


export default function Agenda({ permissoes }) {
    const { setLoading } = useAuth();

    const cores = {
        "Acompanhamento Replantio": "#27AE60",
        "Vistoria": "#3498db"
    }

    //eventos da agenda
    const [eventos, setEventos] = useState([]);

    //Requerimentos que estão aguardando agendamento
    const [requerimentos, setRequerimentos] = useState([]);

    //Estado que guarda o id do requerimento
    const [requerimentoId, setRequerimentoId] = useState(null);

    //Cabeçalhos da tabela
    const headers = [
        { value: "Requerente", objectValue: "requerente", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Etapa", objectValue: "etapa", align: "left" },
        { value: "Prazo", objectValue: "prazoRequerimento", align: "left" },
    ]

    //Função do botão visualizar da lista
    const visualizar = (row) => {
        setRequerimentoId(row.id);
    };

    //Ações que a tabela terá
    const actions = [actionsTable.visualizar(visualizar)];

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    const toggleModal = () => setVisibleModal(!visibleModal);

    //Função acionada no duplo clique de um evento
    const onClickEvento = (event) => {
        if (event.quantidadeDia > 1) {
            loadRequerimentosAgendamentosDia(event);
        } else {
            setRequerimentoId(event.requerimentoId);
        }
    }

    const loadAgenda = () => {
        setLoading(true);
        agenda_api.getList().then(response => {
            response.data = response.data.map(value => {
                const dataAgendamento = new Date(value.dataAgendamento);
                return {
                    id: value.id,
                    requerimentoId: value.requerimento_Id,
                    start: dataAgendamento,
                    end: dataAgendamento,
                    title: value.origem.split(" ")[0],
                    backgroundColor: cores[value.origem],
                    quantidadeDia: value.quantidadeDia,
                    origem: value.origem
                }
            })
            setEventos(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega os requerimentos que estão em etapa de agendamento
    const loadRequerimentosParaAgendamento = () => {
        setLoading(true);
        requerimento_api.getListRequerimentoAgendamento().then(response => {
            response.data.map(value => {
                value.prazoRequerimento = moment(value.prazoRequerimento).format("DD/MM/YYYY");
            })
            setRequerimentos(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega os itens que vão ser exibidos na tabela de requerimentos agendados naquele dia
    const loadRequerimentosAgendamentosDia = (evento) => {
        setLoading(true);
        const filtros = {
            origem: evento.origem,
            dataAgendamentos: evento.start
        }
        requerimento_api.getListRequerimentoAgendamentosDia(filtros).then(response => {
            response.data.map(value => {
                value.prazoRequerimento = moment(value.prazoRequerimento).format("DD/MM/YYYY");
            })
            setRequerimentos(response.data);
            toggleModal();
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadAgenda();
        loadRequerimentosParaAgendamento();
    }, []);

    if (requerimentoId)
        return (
            <FichaRequerimento requerimentoId={requerimentoId} btnVoltar={() => {
                loadAgenda();
                loadRequerimentosParaAgendamento();
                setVisibleModal(false);
                setRequerimentoId(null);
            }} />
        )

    return (
        <>
            <ModalCustomized toggle={toggleModal} isOpen={visibleModal} title={"Agendar fiscalização"} btnClose={true}>
                <Row>
                    <Col md="12" lg="12">
                        <TabelaListagem
                            headers={headers}
                            items={requerimentos}
                            title='Lista de requerimentos'
                            actions={actions}
                        />
                    </Col>
                </Row>
            </ModalCustomized>
            <Calendar
                eventPropGetter={(event) => {
                    return {
                        style: {
                            backgroundColor: event.backgroundColor ? event.backgroundColor : '#3f51b5',
                            borderRadius: '8px',
                            minHeight: '10px',
                        },
                    };
                }}
                localizer={localizer}
                events={eventos}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500, width: "100%" }}
                className={"mt-4"}
                messages={defaultMessages}
                popup={true}
                onDoubleClickEvent={onClickEvento}
                onSelectSlot={(slotInfo) => {
                    if (new Date(moment(slotInfo.start).format("YYYY-MM-DD")) < new Date(moment().format("YYYY-MM-DD"))) {
                        showMessage("Aviso", "Você não pode realizar um agendamento em uma data anterior a de hoje", "info", null);
                        return;
                    }
                    toggleModal();
                }}
                selectable
                resizable
            />
        </>
    )
}